import React from "react";
import { Typography } from "../../components/Typography/Typography";
import { useTranslation } from "react-i18next";
import mightierLogo from "../../assets/mightier-logo.svg";

interface IntakeFormScreenContainerProps {
  title: string;
}

const EMAIL_ADDR = "clinicalservices@mightier.com";

export const IntakeFormScreenContainer = React.memo<React.PropsWithChildren<IntakeFormScreenContainerProps>>(
  (props) => {
    const { t } = useTranslation();

    return (
      <div className="mt-12 flex w-full flex-col items-center justify-center px-4 pb-8 md:w-[50%] md:px-0">
        {/* header */}
        <div className="flex w-3/4 flex-col items-center md:w-1/2">
          <img src={mightierLogo} className="w-full max-w-[288px]" />
          <Typography className="mt-4 text-center">{props.title}</Typography>
        </div>

        {/* CONTENT (children) */}
        <div className="mt-4 w-full">{props.children}</div>

        {/* footer */}
        <div className="mt-8 self-start">
          <Typography variant="h3">{t("intakeFooter.header")}</Typography>
          <Typography>
            {t("intakeFooter.contact1")} <span className="whitespace-nowrap">(978) 254-4371</span>
          </Typography>
          <Typography>
            {t("intakeFooter.contact2")}{" "}
            <a href={`mailto: ${EMAIL_ADDR}`} className="underline">
              {EMAIL_ADDR}
            </a>
          </Typography>
        </div>
      </div>
    );
  },
);

IntakeFormScreenContainer.displayName = "IntakeFormScreenContainer";
